import * as React from "react"
const GroupIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        {...props}
    >
        <mask
            id="a"
            width={24}
            height={24}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: "alpha",
            }}
        >
            <path fill={props.fill || "#CBCBCB"} d="M0 0h24v24H0z" />
        </mask>
        <g mask="url(#a)">
            <path
                fill={props.fill || "#CBCBCB"}
                d="M8 16h12V6H8v10Zm0 2c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 6 16V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 8 2h12c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 18H8Zm-4 4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20V6h2v14h14v2H4Z"
            />
        </g>
    </svg>
)
export default GroupIcon
